import { render, staticRenderFns } from "./panel-cart-sidebar.vue?vue&type=template&id=501bb9b6&"
import script from "./panel-cart-sidebar.vue?vue&type=script&lang=js&"
export * from "./panel-cart-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./panel-cart-sidebar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports